import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button } from 'antd';
import { Row, Col, Spinner, Alert } from 'reactstrap';
import axios from '../../utils/request';

let workprovinceoption = [];
let personIds = "";
let applyIds = "";
let jobIds = "";
let processId = "";
let tenantId = "";
let userId = "";
let workprovince = "";

export class NewHopeWorkProvince extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            workprovinceoption:[],
            personIds: "",
            applyIds: "",
            jobIds: "",
            processId: "",
            tenantId: "",
            userId:"",
            workprovince : ""
        }
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        let messageCode = urlParams.get("messageCode");
        if (!commonParamater) {
            this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
            return;
        }
        this.loadPage(tenantId, commonParamater);
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/NewHope/NewHopeWorkProvince", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "获取省份列表失败！" + res.data.message
                } else {
                    if (resdata !== "") {
                        errorMessage = "";
                        tenantId = resdata.baseinfo.tenantId;
                        userId = resdata.baseinfo.userId;
                        personIds = resdata.baseinfo.applicantIds;
                        jobIds = resdata.baseinfo.jobIds;
                        applyIds = resdata.baseinfo.applyIds;
                        processId = resdata.baseinfo.processId
                        workprovinceoption = resdata.workprovince;
                        this.setState({
                            tenantId: tenantId,
                            userId: userId,
                            personIds: personIds,
                            jobIds: jobIds,
                            applyIds: applyIds,
                            processId: processId,
                            workprovinceoption: workprovinceoption
                        })
                    } else {
                        errorMessage = "获取省份列表为空！";
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    onFinish = (values) => {
        tenantId = this.state.tenantId;
        userId = this.state.userId;
        personIds = this.state.personIds;
        workprovince = this.state.workprovince;
        workprovinceoption = this.state.workprovinceoption;
        const params = {
            tenantId,
            userId,
            personIds,
            workprovince,
            workprovinceoption
        }
        const bodyString = JSON.stringify(params);
        axios
            .post("/api/NewHope/UpdateApplicantStatus",
                bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                const resback = res.data.message;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "提交失败" + resback
                } else {
                    errorMessage = "提交成功"
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    selectedValue = (value) => {
        if (value !== "") {
            workprovince = value;
            this.setState({
                workprovince: workprovince
            })
        }
    };


    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <div style={{ width: "80%", textAlign: "center", padding: "32px" }}>
                        <div><h2>确认录用信息</h2></div>
                        <Form onFinish={this.onFinish}>
                            <Form.Item
                                name="workprovince"
                                label="工作省份"
                                required
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择省份',
                                    },
                                ]}
                            >
                                <Select showSearch
                                    placeholder="---请选择---"
                                    onChange={this.selectedValue}
                                >
                                    {workprovinceoption.map(name => <Select.Option key={name.text}>{name.text}</Select.Option>)}
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button type="prmary" htmlType="submit">提交</Button>
                            </Form.Item>
                        </Form>
                    </div>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}